import * as React from 'react';

const PortalOneColumnLayout: React.FC<React.PropsWithChildren<{ className?: string }>> = (props) => (
	<div className={`portalContentWrapper portalOneColumnLayout container ${props?.className}`}>
		{props.children}
		<div className="clear" />
	</div>
);

export { PortalOneColumnLayout };
